import { Fragment } from "react";

/**
 * Marque produit — même convention que cywiz.fr :
 *   • dans les titres, la navigation et le corps de texte → Cywiz avec VR en exposant
 *   • dans les contextes qui n'acceptent pas de mise en forme (balise <title>,
 *     meta, attribut alt, valeur de formulaire, e-mail) → « Cywiz » tout court
 *
 * Un seul endroit pour l'écrire : le nom doit rester identique partout et
 * cohérent avec le site produit, où l'internaute atterrit ensuite.
 */
export const CywizMark = ({ className = "", plain = false }) => {
  if (plain) return <span className={className}>Cywiz</span>;

  return (
    <span className={`whitespace-nowrap ${className}`}>
      Cywiz
      <sup className="ml-[0.08em] text-[0.5em] font-normal tracking-[0.08em] align-super">
        VR
      </sup>
    </span>
  );
};

/**
 * Rend une chaîne de traduction en remplaçant le jeton {cywiz} par la marque.
 *
 *   contenu : "Notre application, {cywiz}, est déjà déployée."
 *   usage   : <CywizText>{t.hero.subtitle}</CywizText>
 *
 * Permet de garder tout le texte dans content.fr.js / content.en.js sans y
 * mettre de JSX, et sans dupliquer la mise en forme de la marque.
 */
export const CywizText = ({ children, markClassName = "", className = "" }) => {
  if (typeof children !== "string") return children;

  // Un seul nœud (span) : évite les trous dans les flex (ex. FAQ accordion
  // avec justify-between) où chaque fragment devenait un item séparé.
  return (
    <span className={className}>
      {children.split("{cywiz}").map((chunk, i, all) => (
        <Fragment key={i}>
          {chunk}
          {i < all.length - 1 && <CywizMark className={markClassName} />}
        </Fragment>
      ))}
    </span>
  );
};
